// Starter Mermaid diagrams offered by the "Insert diagram" menu in the editors.
// `code` is the raw mermaid source (no fences); the editor wraps it appropriately
// for Markdown mode (```mermaid fences) or Visual mode (a mermaid code block).
export const MERMAID_TEMPLATES = [
  {
    key: 'flowchart',
    label: 'Flowchart',
    code: `flowchart TD
    A[Start] --> B{Decision?}
    B -->|Yes| C[Do this]
    B -->|No| D[Do that]`,
  },
  {
    key: 'sequence',
    label: 'Sequence',
    code: `sequenceDiagram
    participant A as Alice
    participant B as Bob
    A->>B: Hello Bob, how are you?
    B-->>A: I'm good, thanks!
    A->>B: Great to hear.`,
  },
  {
    key: 'timeline',
    label: 'Timeline',
    code: `timeline
    title Project Timeline
    2023 : Idea : Planning
    2024 : Build : Testing
    2025 : Launch`,
  },
  {
    key: 'gantt',
    label: 'Gantt chart',
    code: `gantt
    title Project Schedule
    dateFormat YYYY-MM-DD
    section Phase 1
    Design   :a1, 2024-01-01, 7d
    Build    :after a1, 14d
    section Phase 2
    Test     :2024-02-01, 5d`,
  },
  {
    key: 'pie',
    label: 'Pie chart',
    code: `pie title Energy Source
    "Solar" : 60
    "Grid" : 25
    "Generator" : 15`,
  },
  {
    key: 'state',
    label: 'State diagram',
    code: `stateDiagram-v2
    [*] --> Idle
    Idle --> Running : start
    Running --> Idle : stop
    Running --> [*]`,
  },
  {
    key: 'class',
    label: 'Class diagram',
    code: `classDiagram
    class Animal {
      +String name
      +eat()
    }
    Animal <|-- Dog
    Animal <|-- Cat`,
  },
];
